import React, { useState } from 'react';
import queryString from 'query-string';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import {
  Paper,
  Button,
  FormControlLabel,
  Checkbox,
  Modal
} from '@material-ui/core';

import { verifyAuthCode } from '../../apiCalls/user/user';
import routes from '../../constants/routes';
import { withLocal } from '../common/LocaleProvider/LocaleProvider';
import { useAlert } from '../common/AlertProvider/AlertProvider';
import { Consent, Footer } from '../common';
import {
  getMobileNumber,
  setMobileNumber as setMobileSession,
  setToken,
  getCallChoice
} from '../../utils/session-utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 16px'
  },
  header: {
    margin: '16px 0px',
    fontFamily: 'times',
    color: theme.palette.primary.dark
  },
  subheader: {
    fontSize: '14px'
  },
  alertText: {
    color: '#ca5ce9',
    marginBottom: '8px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  checkbox: {
    color: theme.palette.primary.main
  },
  kmsiDetailsBtn: {
    textTransform: 'none',
    fontSize: '16px',
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalBody: {
    position: 'absolute',
    maxWidth: '320px',
    fontSize: '14px',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2)
  },
  error: {
    color: '#e02020'
  },
  kmsiAnimate: {
    border: '2px solid #FFFFFF',
    'border-radius': '4px',
    'animation-name': 'kmsiBorderBlink',
    'animation-duration': '0.75s',
    'animation-iteration-count': '3'
  }
}));

const EnterCode = ({ history, locale }) => {
  const classes = useStyles();
  const { c: initCode, m: phoneFromParams } = queryString.parse(
    history.location.search
  );

  const mobileNumber = getMobileNumber() || phoneFromParams;
  const subheader_2 = getCallChoice()
    ? locale.code.subheader_2_opt
    : locale.code.subheader_2;

  const { setAlert } = useAlert();
  const [code, setCode] = useState(initCode || '');
  const [kmsi, setKmsi] = useState(false);
  const [openKmsiDetails, setOpenKmsiDetails] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = () => {
    setError(null);
    setDisableSubmit(true);

    verifyAuthCode(
      { mobileNumber, code, kmsi },
      res => {
        setToken(res.token);
        setMobileSession(mobileNumber);
        setAlert({ text: 'Login successful', type: 'success' });
        history.push(
          res.neverShowAgain
            ? routes.CREATE_ACCOUNT
            : routes.PRE_SCREEN_INSRUCTIONS
        );
      },
      message => {
        setDisableSubmit(false);
        setError(message);
      }
    );
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>{locale.header}</h1>
        <p className={classes.subheader}>
          {`${locale.code.subheader_1} ${mobileNumber} ${subheader_2}`}
        </p>

        <ValidatorForm className={classes.form} onSubmit={() => onSubmit()}>
          {error && <span className={classes.error}>{error}</span>}
          <TextValidator
            id="code"
            name="code"
            inputMode="numeric"
            label={locale.input_labels.code}
            value={code}
            onChange={e => setCode(e.target.value)}
            validators={['required']}
            errorMessages={['this field is required']}
            variant="outlined"
            inputProps={{
              'data-testid': 'code'
            }}
          />
          <div className={classes.kmsiAnimate}>
            <FormControlLabel
              style={{ margin: 0 }}
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={kmsi}
                  onChange={() => setKmsi(!kmsi)}
                  name="kmsi"
                  color="primary"
                  inputProps={{
                    'data-testid': 'kmsi-checkbox'
                  }}
                />
              }
              label={locale.button_labels.kmsi}
            />
            <Button
              className={classes.kmsiDetailsBtn}
              disableRipple
              color="primary"
              data-testid="kmsi-button"
              variant="text"
              onClick={() => setOpenKmsiDetails(true)}
            >
              {locale.button_labels.kmsi_details}
            </Button>
          </div>
          <Button
            id="btn-send-validate"
            className={classes.button}
            type="submit"
            color="primary"
            variant="contained"
            disabled={!code || disableSubmit}
          >
            {locale.button_labels.submit}
          </Button>
          <span style={{ marginTop: '16px' }}>{locale.code.new_code_text}</span>
          <Link to="/" style={{ width: 'fit-content' }}>
            {locale.code.new_code_link}
          </Link>
        </ValidatorForm>
        <Consent style={{ marginTop: '40px' }} locale={locale} />
        <Footer locale={locale} />
      </Paper>
      <Modal
        className={classes.modal}
        open={openKmsiDetails}
        onClose={() => setOpenKmsiDetails(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-testid="kmsi-details"
      >
        <Paper className={classes.modalBody}>
          <p>{locale.code.kmsi_details_1}</p>
          <p>{locale.code.kmsi_details_2}</p>
        </Paper>
      </Modal>
    </div>
  );
};

export default withLocal(EnterCode);
